import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'LoadingSpinnerComponent'
})
export default class LoadingSpinnerComponent extends Vue {
  @Prop() public alignVertically: boolean;
  @Prop() public message: string;
  @Prop() public overrideColour: string;

  private getLoadingMessage(): string {
    return this.message || this.$lang.app.loading;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/shared-components/loading-spinner/loading-spinner.component.ts